<template>
  <v-app id="forgot" class="back">
       <v-content>
      <v-container
        class="fill-height"
        fluid
      >
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            sm="8"
            md="4"
          >
            <v-card class="pa-7"  id="login">
                <v-snackbar v-model="snackbar" :timeout="4000" top color="success">
                  <span>Successfull...</span>
                     <v-btn text color="white" @click="snackbar = false">Close</v-btn>
                </v-snackbar>

                <v-card-text class="text-center">
                    <h1 class="white--text">Forgot Password</h1>
                    <p class="white--text my-4">A new password will be sent to your mailbox.</p>               
                </v-card-text>
                <v-container class="mt-n5">
                <v-card-text>
                    <v-form>
                  <v-text-field
                    label="Enter your username"
                    v-model="username" :rules="userRules" 
                    prepend-inner-icon="mdi-account"
                    type="text" single-line
                    solo required color="#08911B"
                  ></v-text-field>
                    </v-form>
                </v-card-text>
                </v-container>
                <v-card-text class="text-center mt-n8">
                <v-btn style="color:#62AE32" class="" v-on:click="reset()">
                        Submit
                </v-btn>
                </v-card-text>

                <v-list-item>
                 <v-btn text  class="white--text forgot" router-link to="/">
                    <v-icon left>mdi-chevron-left</v-icon>
                        Back to Login
                </v-btn>
                </v-list-item>
        
              
       
            </v-card>
          </v-col>
        </v-row> 
      </v-container>
    </v-content>
  </v-app>
    
</template>

<script>
export default {
    data(){
        return{
            username: '',
            snackbar: false,
             emailRules: [
               v => !!v || 'Username is required',
               v => /.+@.+/.test(v) || 'Username must be valid',
            ],
        }
    },
    methods:{
        reset(){
        this.$store.dispatch("forgotPassword",{
          "username": this.username
        })
        .then(()=>{
              this.snackbar = true;
        })
        .catch(()=>{
        })
     }
    }
}
</script>

<style scoped>
.back{
background: url('/mainBackground.png');
background-size: cover;
}
.v-card:not(.v-sheet--tile) {
    border-radius: 28px;
}
.forgot-color{
 color:#5F5D5D;   
}
.size{
    font-size: 15px;
}
 #login{
        background: rgba(98, 174, 50, 0.7);
        border-radius: 5px;
    }
    .forgot{
        text-transform: capitalize;
    }
</style>